/*@flow*/
import isNil from './isNil';
import isArray from './isArray';

export default function isObject(x: any): %checks {
  return !isNil(x) && typeof x === 'object' && !isArray(x);
}
